import { render, staticRenderFns } from "./RankingHeadToHead.vue?vue&type=template&id=0d1317ff&scoped=true&"
import script from "./RankingHeadToHead.vue?vue&type=script&lang=js&"
export * from "./RankingHeadToHead.vue?vue&type=script&lang=js&"
import style0 from "./RankingHeadToHead.vue?vue&type=style&index=0&id=0d1317ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1317ff",
  null
  
)

export default component.exports